import React from "react";
import { makeStyles, Container, Grid } from "@material-ui/core";

import WebToonInfo from "../../../components/MainComponent/WebToonComponent/WebToonInfo";
import { GET_WEBTOON_BY_ID } from "../../../quries/webtoon";
import { useQuery } from "@apollo/client";
import { useState } from "react";
import { useEffect } from "react";
import WebToonImgList from "../../../components/MainComponent/WebToonComponent/WebToonImgList";
import MetaSeo from "../../../components/MetaSeo";
import WebtoonNavigation from "../../../components/MainComponent/WebToonComponent/WebtoonNavigation";

const useStyles = makeStyles((theme) => ({
  webtoonTopContainer: {
    //   minHeight: "100vh",
    paddingTop: "10rem",
    // paddingLeft: "4rem",
    // paddingRight: "4rem",
    margin: " 0 -15px",
    // marginTop: " -20vh",
    paddingBottom: "4rem",
    [theme.breakpoints.down("xs")]: {
      margin: 0,
      paddingTop: "5rem",
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
}));

interface WebToonContainerProps {
  //   children: React.ReactNode | null | string | undefined;
  history: any;
  match: any;
}

function WebToonContainer({ history, match }: WebToonContainerProps) {
  const classes = useStyles();

  const [title, setTitle] = useState<any>(null);
  const [parentId, setParentId] = useState<any>(null);
  const [imgArr, setImgArr] = useState<any>([]);

  const { data, loading, error } = useQuery(GET_WEBTOON_BY_ID, {
    fetchPolicy: "no-cache",

    variables: {
      id: match.params.webtoon_id,
    },
  });

  useEffect(() => {
    if (data && data.webToon) {
      setTitle(data.webToon.title);
      console.log(data.webToon);
      setParentId(data.webToon.web_toons_program.id);
      // let webToonImageArr = data.webToon.webtoon_image;
      let webToonImageArr = data.webToon.webtoon;

      webToonImageArr.map((img: any, index: any) => {
        setImgArr((prev: any) => {
          return [
            ...prev,
            {
              id: img.id,
              url: img.url,
            },
          ];
        });
      });
    }
    return () => {
      setTitle(null);
      setImgArr([]);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.webToon) {
    console.log(error);
  }

  return (
    <Container
      maxWidth={"lg"}
      disableGutters
      style={
        {
          // minHeight: "150vh"
        }
      }
    >
      <MetaSeo
        data={{
          title: title,
          description: title,
          canonical: `http://laborbusan.or.kr/webtoon/view/${match.params.webtoon_id}`,
          image: `http:/laborbusan.or.kr${
            imgArr && imgArr.length > 0 ? imgArr[0].url : ""
          }`,
        }}
      />
      <Grid
        xs={12}
        item
        container
        justify="center"
        className={classes.webtoonTopContainer}
      >
        <WebtoonNavigation id={match.params.webtoon_id} parentId={parentId} />

        <WebToonInfo categoryInfo={null} title={<div>{title}</div>} />

        {imgArr.length > 0 ? (
          imgArr.map((img: any, index: any) => {
            return (
              <React.Fragment key={`webtoon-view-${img.url}-${index}`}>
                <WebToonImgList url={img.url}></WebToonImgList>
              </React.Fragment>
            );
          })
        ) : (
          <div></div>
        )}
      </Grid>
    </Container>
  );
}

export default WebToonContainer;
